export default __webpack_public_path__ + "static/arriba-derecha-2d8e6359781194d85f2bec2f761287f4.png";